import { Box, Container } from "@chakra-ui/react";
import { FC } from "react";
import { useUserData } from "../../hooks/useUserData";
import {
    Banner,
    Card,
    CustomedSpinner,
    PageHeader,
} from "../../shared/components";
import { BannerClass } from "../../shared/components/Banner/utils";
import { TelevisionTable } from "../../shared/components/Tables";

import bannerImage from "../../img/bannerTv/telew_top.jpg";
import { env } from "../../env";
import { useGponList } from "../../hooks/useGponList";
import { useTr069List } from "../../hooks/useTr069List";
import { useStbList } from "../../hooks/useStbList";
import { GponDevicesCard } from "../../shared/components/Cards/GponDevices";
import { Tr069DevicesCard } from "../../shared/components/Cards/Tr069Devices";
import { StbDevicesCard } from "../../shared/components/Cards/StbDevices";

export const Devices: FC = () => {
    
    const gponList = useGponList();
    const tr069List = useTr069List();
    const stbList = useStbList();
    const userData = useUserData();

    const bannerDetails = new BannerClass(env.REACT_APP_USE_USER_CODE === 'true' ? userData.data?.usercode : userData.data?.userno);



    return (
        <>
            <Banner bannerImage={bannerImage} {...bannerDetails} />
            <Container maxWidth={"container.xl"} flexDir={"column"} >
                <PageHeader title="Urządzenia" onlyMobile />
                <Box mb={5}>
                    {gponList.isLoading ? <CustomedSpinner /> : <GponDevicesCard gponDevices={gponList.data} />}
                </Box>
                <Box mb={5}>
                    {tr069List.isLoading ? <CustomedSpinner /> : <Tr069DevicesCard tr069Devices={tr069List.data} />}
                </Box>
                <Box mb={5}>
                    {stbList.isLoading ? <CustomedSpinner /> : <StbDevicesCard stbDevices={stbList.data} />}
                </Box>
            </Container>
        </>
    );
};
